import i18n from '@/i18n'
import Swal from 'sweetalert2'

export const proceedWithConfirmation = async ({
    message,
    callback,
    title = null,
    onConfirm = null,
    onDismiss = null,
    onFinished = null,
    onError = null,
    confirmButtonColor = '#009BDB',
    allowOutsideClick = false,
    input = null,
    inputPlaceholder = '',
    inputValidator = null,
    icon = '',
    type = '',
    confirmButtonText = i18n.t('notification.yes'),
    cancelButtonText = i18n.t('notification.no'),
}) => {
    return Swal.fire({
        icon: icon,
        type: type,
        title:
            title == null
                ? `<span style="color:#022b4f">${i18n.t('notification.areYouSure')}</span>`
                : `<span style="color:#022b4f">${title}</span>`,
        html: message,
        confirmButtonColor,
        confirmButtonText,
        cancelButtonText,
        allowOutsideClick,
        showLoaderOnConfirm: true,
        showCancelButton: true,
        input: input,
        inputPlaceholder: inputPlaceholder,
        inputValidator: inputValidator,
        preConfirm: () => {
            return onConfirm()
        },
    })
        .then((resp) => {
            if (resp.value && callback) {
                callback(resp.value)
            } else if (onDismiss) {
                onDismiss()
            }

            return !!resp.value
        })
        .catch(() => {
            if (onError) {
                onError()
            }
        })
        .finally(() => {
            if (onFinished) {
                onFinished()
            }
        })
}
